import { ContactStatus } from "@libs/gateways/practice/PracticeGateway.dtos.ts";
import { toAddressDto } from "@modules/practice/screens/shared-components/utils/contact.utils.ts";
import { Contact } from "@stores/practice/models/Contact.ts";
import { PracticeStore } from "@stores/practice/PracticeStore.ts";
import { RootStore } from "@stores/root/RootStore.ts";

import { PatientDemographicHelper } from "../../context/PatientDemographicHelper.ts";
import { ContactEditFormValues } from "../../shared-components/edit/PatientEditFormValues.tsx";
import {
  getCommTypePreferences,
  toCommunicationDto,
  toRelationshipDto,
  toRelationshipDtoFromEmployerField
} from "../../shared-components/edit/utils.tsx";

const submitPicture = async (
  contact: Contact,
  fileStagingId: string,
  practice: PracticeStore
) => {
  await practice.updateProfilePicture({
    entityId: contact.id,
    fileStagingId
  });
};

export const onSubmit = async (
  contact: Contact | undefined,
  formOptions: {
    values: ContactEditFormValues;
    initialValues: ContactEditFormValues;
  },
  options: {
    root: RootStore;
    helper: PatientDemographicHelper;
  }
) => {
  const { root, helper } = options;
  const { notification, practice, comms } = root;
  const { values, initialValues } = formOptions;

  const {
    relationships: relationshipsValues,
    firstName,
    lastName,
    title,
    status,
    profilePictureUrl,
    appointmentReminderType,
    appointmentReminderValue,
    appointmentConfirmationType,
    appointmentConfirmationValue,
    invoiceCommunicationType,
    invoiceCommunicationValue,
    employers,
    ...restValues
  } = values;

  const baseRequest = {
    ...restValues,
    fullName: {
      firstName,
      lastName,
      title
    },
    contactStatus: status,
    communications: toCommunicationDto(values.communications),
    addresses: toAddressDto(values.addresses),
    relationships: toRelationshipDto(relationshipsValues)
  };

  if (employers && employers.length > 0) {
    baseRequest.relationships.push(
      ...toRelationshipDtoFromEmployerField(employers)
    );
  }

  let updatedIndividual: Contact;

  if (!!initialValues.profilePictureUrl && !values.profilePictureUrl) {
    try {
      await practice.deleteProfilePicture(contact?.id!);
    } catch {
      notification.error("Error occurred while removing profile photo");
    }
  }

  if (!values.id) {
    updatedIndividual = await practice.addIndividual({
      ...baseRequest,
      fullName: baseRequest.fullName,
      addresses: baseRequest.addresses,
      contactStatus: ContactStatus.Active
    });
  } else {
    updatedIndividual = await practice.updateIndividual({
      id: values.id,
      ...baseRequest
    });
  }
  if (updatedIndividual)
    await comms.addOrUpdateContactPreferences(
      updatedIndividual.id,
      getCommTypePreferences(values)
    );
  if (helper.profilePictureStagingId && updatedIndividual) {
    // stores picture and fetches contact with new picture url
    await submitPicture(
      updatedIndividual,
      helper.profilePictureStagingId,
      practice
    );
  }
};
